// router.js
import Vue from 'vue';
import Router from 'vue-router';
import Home from '../views/Home.vue';
import About from '../views/About.vue';
import Contact from '../views/Contact.vue';
import Products from '../views/Products.vue'
import ProductDetail from '../components/ProductDetail.vue'

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/home',
      name: '首页',   //这是路由的名字，通常用于编程式导航或页面引用。
      component: Home,    //这是当 URL 匹配该路径时要加载的 Vue 组件。
	  beforeEnter(to, from, next) {
	        // 在进入 Page1 页面时设置 banner 背景图片和文字
	        next(vm => {
	          vm.$root.setBannerImageAndText('首页');
	        });
	      },
    },
      {
          path: '/about',
          name: '关于我们',   //这是路由的名字，通常用于编程式导航或页面引用。
          component: About,    //这是当 URL 匹配该路径时要加载的 Vue 组件。
          beforeEnter(to, from, next) {
              // 在进入 Page1 页面时设置 banner 背景图片和文字
              next(vm => {
                  vm.$root.setBannerImageAndText('关于我们');
              });
          },
      },
      {
          path: '/products',
          name: '产品中心',   //这是路由的名字，通常用于编程式导航或页面引用。
          component: Products,    //这是当 URL 匹配该路径时要加载的 Vue 组件。
          meta: { bannerText: '产品中心' },
          beforeEnter(to, from, next) {
              // 在进入 Page1 页面时设置 banner 背景图片和文字
              next(vm => {
                  vm.$root.setBannerImageAndText('产品中心');
              });
          },
      },
      {
          path: '/products/:id', // 动态路径参数，用于捕获产品ID
          name: 'ProductDetail', // 路由名称
          component: ProductDetail // 当路由匹配时渲染的组件
      },

    {
      path: '/contact',
      name: '联系我们',
      component: Contact,
	  beforeEnter(to, from, next) {
	        // 在进入 Page2 页面时设置 banner 背景图片和文字
	        next(vm => {
	          vm.$root.setBannerImageAndText('联系我们');
	        });
	      },
    }

    // 可以添加更多的路由
  ]
});